import { render, staticRenderFns } from "./image2.vue?vue&type=template&id=fba42896&scoped=true"
import script from "./image2.vue?vue&type=script&lang=js"
export * from "./image2.vue?vue&type=script&lang=js"
import style0 from "./image2.vue?vue&type=style&index=0&id=fba42896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba42896",
  null
  
)

export default component.exports